import interpolateStringUtil from 'utils/string/interpolate/index.js'

export default function formatMessageIntlUtil (intl, message, params = {}) {
  if (message == null) {
    console.warn('[notFound]: message not found: ', params)
    return ''
  }

  if (!intl) {
    return interpolateStringUtil(
      message.defaultMessage,
      params
    )
  }

  return intl.formatMessage(message, {
    br: '\n',
    ...params
  })
}
